<template>
  <div class="contact-form-section section-space--ptb_120" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 order-2 order-lg-1">
          <div class="section-title text-left section-space--mb_60">
            <h2 class="mb-15 wow move-up font-weight-800 underline">
              Contacto
            </h2>
            <br />
            <span class="section-text_left wow move-up mt-20">
              Escríbenos y cuéntanos tu proyecto; en breve te contactaremos sin compromiso.
            </span>
            <h6 class="mt-20 font-weight-700">¡Nosotros te podemos ayudar!</h6>
          </div>
          <div class="contact-from-wrapper wow move-up">
            <form id="contact-form" @submit.prevent="validate" novalidate>
              <div class="contact-page-form">
                <div class="contact-input">
                  <div class="contact-inner">
                    <label class="sr-only" :for="fieldIds.name">Tu nombre</label>
                    <input
                      :id="fieldIds.name"
                      name="con_name"
                      type="text"
                      placeholder="Tu nombre *"
                      autocomplete="name"
                      v-model.trim="$v.form.name.$model"
                      :aria-invalid="$v.form.name.$error"
                      :aria-describedby="`${fieldIds.name}-error`"
                      required
                    />
                    <span
                      class="error-message"
                      v-if="$v.form.name.$error"
                      :id="`${fieldIds.name}-error`"
                      role="alert"
                    >
                      Campo requerido
                    </span>
                  </div>
                  <div class="contact-inner">
                    <label class="sr-only" :for="fieldIds.email">Tu correo electrónico</label>
                    <input
                      :id="fieldIds.email"
                      name="con_email"
                      type="email"
                      placeholder="Tu correo *"
                      autocomplete="email"
                      v-model.trim="$v.form.email.$model"
                      :aria-invalid="$v.form.email.$error"
                      :aria-describedby="`${fieldIds.email}-error`"
                      required
                    />
                    <span
                      class="error-message"
                      v-if="$v.form.email.$dirty && !$v.form.email.required"
                      :id="`${fieldIds.email}-error`"
                      role="alert"
                    >
                      Campo requerido
                    </span>
                    <span
                      class="error-message"
                      v-else-if="$v.form.email.$dirty && !$v.form.email.email"
                      :id="`${fieldIds.email}-error`"
                      role="alert"
                    >
                      Correo inválido
                    </span>
                  </div>
                </div>
                <div class="contact-input">
                  <div class="contact-inner">
                    <label class="sr-only" :for="fieldIds.phone">Tu teléfono</label>
                    <input
                      :id="fieldIds.phone"
                      name="con_phone"
                      type="text"
                      placeholder="Tu teléfono *"
                      autocomplete="tel"
                      v-model.trim="$v.form.phone.$model"
                      v-mask="'(###)-###-####'"
                      :aria-invalid="$v.form.phone.$error"
                      :aria-describedby="`${fieldIds.phone}-error`"
                      required
                    />
                    <span
                      class="error-message"
                      v-if="$v.form.phone.$error"
                      :id="`${fieldIds.phone}-error`"
                      role="alert"
                    >
                      Campo requerido
                    </span>
                  </div>
                  <div class="contact-inner">
                    <label class="sr-only" :for="fieldIds.service">Servicio de tu interés</label>
                    <select
                      :id="fieldIds.service"
                      name="con_services"
                      v-model.trim="$v.form.service.$model"
                      :aria-invalid="$v.form.service.$error"
                      :aria-describedby="`${fieldIds.service}-error`"
                      required
                    >
                      <option disabled value="">Selecciona el servicio de tu interés</option>
                      <option
                        v-for="(service, index) in services"
                        :key="index"
                        :value="service"
                      >
                        {{ service }}
                      </option>
                    </select>
                    <span
                      class="error-message"
                      v-if="$v.form.service.$error"
                      :id="`${fieldIds.service}-error`"
                      role="alert"
                    >
                      Campo requerido
                    </span>
                  </div>
                </div>
                <div class="contact-inner contact-message">
                  <label class="sr-only" :for="fieldIds.need">Describe tu necesidad</label>
                  <textarea
                    :id="fieldIds.need"
                    name="con_message"
                    placeholder="Describe tu necesidad *"
                    v-model.trim="$v.form.need.$model"
                    rows="6"
                    :aria-invalid="$v.form.need.$error"
                    :aria-describedby="`${fieldIds.need}-error`"
                    required
                  ></textarea>
                  <span
                    class="error-message"
                    v-if="$v.form.need.$error"
                    :id="`${fieldIds.need}-error`"
                    role="alert"
                  >
                    Campo requerido
                  </span>
                </div>
                <div class="contact-submit-btn">
                  <button
                    class="btn btn--accent-500"
                    type="submit"
                    :disabled="sending"
                  >
                    {{ buttonMessage }}
                  </button>
                  <p class="form-messege" aria-live="polite"></p>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-lg-5 order-1 order-lg-2">
          <div class="peatures_image-wrap section-space--mb_40">
            <div class="image text-center wow move-up">
              <img
                class="img-fluid"
                src="../assets/img/features/img-contacto.png"
                alt="Equipo Leonix en sesión de trabajo"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from 'emailjs-com'
import { required, email } from 'vuelidate/lib/validators'
export default {
  name: 'ContactForm',
  validations: {
    form: {
      name: { required },
      email: { required, email },
      phone: { required },
      service: { required },
      need: { required },
    },
  },
  data() {
    return {
      sending: false,
      buttonMessage: 'Enviar',
      form: {
        name: '',
        email: '',
        phone: '',
        service: '',
        need: '',
      },
      services: [
        'Necesito una aplicación móvil',
        'Necesito una página web',
        'Requiero un sistema para mi negocio o empresa',
        'Necesito un logo o branding',
        'Necesito ayuda para administrar mi sitio',
        'No sé por dónde empezar, necesito asesoría',
        'Otro',
      ],
      fieldIds: {
        name: 'contact-name',
        email: 'contact-email',
        phone: 'contact-phone',
        service: 'contact-service',
        need: 'contact-need',
      },
    }
  },
  methods: {
    validate() {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) this.sendEmail()
    },
    sendEmail() {
      this.buttonMessage = 'Enviando...'
      this.sending = true
      emailjs
        .send(
          'service_j48wtf5',
          'template_5adq324',
          {
            from_name: this.form.name,
            to_name: 'Leonix',
            mail: this.form.email,
            phone: this.form.phone,
            service: this.form.service,
            message: this.form.need,
          },
          'gWY8hLA_YWOFadA4A'
        )
        .then(
          () => {
            this.$swal(
              '¡Mensaje enviado!',
              '¡Gracias por contactarnos! En breve nos pondremos en contacto contigo.',
              'success'
            )
            this.resetForm()
          },
          () => {
            this.buttonMessage = 'Enviar'
            this.sending = false
          }
        )
    },
    resetForm() {
      this.buttonMessage = 'Enviar'
      this.sending = false
      this.form.name = ''
      this.form.email = ''
      this.form.phone = ''
      this.form.service = ''
      this.form.need = ''
      this.$v.form.$reset()
    },
  },
}
</script>

<style scoped>
.sr-only {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.contact-inner {
  margin-bottom: 18px;
}

.contact-inner input,
.contact-inner select,
.contact-inner textarea {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 16px;
  color: #333;
  transition: all 0.25s ease;
  outline: none;
}

.contact-inner input:hover,
.contact-inner select:hover,
.contact-inner textarea:hover {
  border-color: #d2d2d2;
}

.contact-inner input:focus,
.contact-inner select:focus,
.contact-inner textarea:focus {
  border-color: #f4a92b;
  box-shadow: 0 0 8px rgba(244, 169, 43, 0.25);
}

::placeholder {
  color: #999;
}

.contact-input {
  display: flex;
  gap: 20px;
}

.contact-input .contact-inner {
  flex: 1;
}

.contact-message textarea {
  height: 160px;
  resize: vertical;
}

.contact-submit-btn button {
  margin-top: 10px;
  width: 220px;
  background: #111;
  color: #fff;
  font-weight: 700;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
  font-size: 18px;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
}

.contact-submit-btn button:hover {
  background: #1a1a1a;
  box-shadow: 0 6px 16px rgba(255, 168, 43, 0.4);
  transform: translateY(-2px);
}

.error-message {
  color: #d63434;
  margin-top: 5px;
  font-size: 13px;
  display: block;
}

@media (max-width: 992px) {
  .contact-input {
    flex-direction: column;
  }
}
</style>
